import { connectionTypeFromDto } from '@features/insuranceCarriers/mappers/connectionTypeMapper';

const credentialsSchemaFromDto = (dto) => {
  if (!dto) return null; // Si no se requiere autenticación el campo 'authentication_schema' llega como 'null'

  return {
    infoText: dto.info_text,
    fields: (dto.fields ?? []).map((field) => ({
      key: field.key,
      label: field.label,
      type: field.type, // 'string', 'number', 'password', 'email', 'date', 'select'
      required: field.required,
      default: field.default ?? undefined,
      options: field.options ?? undefined, // Se espera solo si type === 'select'. Formato: [{ value: any, label: string }, ...]
      helpText: field.help_text ?? undefined,
    })),
  };
};

const connectionTypesFromDto = (dto) => (
  (dto ?? []).map((item) => ({
    ...connectionTypeFromDto(item),
    description: item.description,
    globalEnabled: item.global_enabled ?? item.enabled, // 'enabled' llega en availableInsuranceCarrierFromDto
    ...(item.brand_enabled !== undefined && { brandEnabled: item.brand_enabled }), // Solo llega en insuranceCarrierFromDto
    ...(item.quotable !== undefined && { quotable: item.quotable }),  // Indica si es cotizable a nivel de conexión. Solo llega en insuranceCarrierFromDto
    credentialsSchema: credentialsSchemaFromDto(item.authentication_schema),
  }))
);

const certificatesFromDto = (dto = []) => (
  (dto ?? []).map((item) => ({
    type: item.type, // 'client', 'ca'
    label: item.label,
    format: item.format, // 'pem', 'pfx'
  }))
);

const agreementCountFromDto = (dto = {}) => {
  if (!dto) return {}

  return {
    active: dto.active,
    inactive: dto.inactive,
  };
};

export const insuranceCarrierFromDto = (dto) => ({
  id: dto.id,
  name: dto.name,
  logoUrl: dto.logo_url,
  connectionTypes: connectionTypesFromDto(dto.connection_types),
  quotable: dto.quotable, // Indica si es cotizable a nivel de aseguradora; al menos una de sus conexiones debe ser cotizable
  certificates: certificatesFromDto(dto.certificates),
  agreementCount: agreementCountFromDto(dto.agreement_count),
  createdAt: dto.created_at,
  updatedAt: dto.updated_at,
});

export const availableInsuranceCarrierFromDto = (dto) => ({
  id: dto.id,
  code: dto.code,
  name: dto.name,
  logoUrl: dto.url,
  connectionTypes: connectionTypesFromDto(dto.connection_types),
});

export const insuranceCarrierFromSoftsegurosFromDto = (dto) => ({
  id: dto.id,
  name: dto.nombre,
});
